import React from "react";
import PropTypes from "prop-types";

import { navigationPropType } from "../../../../state/modules/navigation";
import ImageCardWithDescription from "./ImageCardWithDescription";
import styles from "./Wrapper.css";

const ImageCardsWithDescription = ({
  item: { items },
  isGradientBackground
}) => {
  return (
    <div className={styles.cardList}>
      {items
        .slice(0, 8)
        .map(item => (
          <ImageCardWithDescription
            item={item}
            key={item.id}
            isGradientBackground={isGradientBackground}
          />
        ))}
    </div>
  );
};

ImageCardsWithDescription.propTypes = {
  item: navigationPropType.isRequired,
  isGradientBackground: PropTypes.bool.isRequired
};

export default ImageCardsWithDescription;



// WEBPACK FOOTER //
// ./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/Wrapper.js